import type { SiteSettings } from "@/mocks/adminData";

const DEFAULT_SERVICE_IMAGE = "https://www.au2p0rz.vip/assets/service-person-pc-BzF-gzlj.webp";

interface ServiceSectionProps {
  settings: SiteSettings;
}

export default function ServiceSection({ settings }: ServiceSectionProps) {
  const serviceTitle = settings.service_title || "一对一专员";
  const defaultDesc = "除指派专员进行日常业务对接外,另委派项目负责人履行监督职能。该负责人统筹项目全局,具备快速决策与纠偏响应能力,旨在最大限度降低沟通成本,保障项目高质量交付,共创双赢局面。";
  const displayDesc = settings.service_desc || defaultDesc;
  const serviceImage = settings.service_image || DEFAULT_SERVICE_IMAGE;

  return (
    <section id="service" className="w-full py-5 md:py-10 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-10">
        <div className="flex items-center gap-2 mb-4 md:mb-6">
          <span className="w-1 h-5 rounded-full bg-red-500 flex-shrink-0"></span>
          <h2 className="text-base md:text-lg font-bold text-gray-800">服务体系</h2>
          <span className="text-xs text-gray-400 ml-1">全程跟进对接,沟通无障碍</span>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <div className="flex flex-col md:flex-row items-center gap-6 p-5 md:p-8">
            <div className="flex-1">
              <h3 className="text-base md:text-lg font-bold text-gray-800 mb-3">{serviceTitle}</h3>
              <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-wrap">
                {displayDesc}
              </p>
            </div>
            <div className="w-36 h-36 md:w-44 md:h-44 flex-shrink-0">
              <img
                src={serviceImage}
                alt="服务专员"
                className="w-full h-full object-cover rounded-xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}